import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                if (decodedToken.exp * 1000 < Date.now()) {
                    localStorage.removeItem('token');
                    setUser(null);
                } else {
                    setUser(decodedToken);
                }
            } catch (error) {
                console.error('Error decoding token:', error);
                localStorage.removeItem('token');
                setUser(null);
            }
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        try {
            const res = await axios.post('https://fitsaveai.uk.r.appspot.com/api/auth/login', { email, password });
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('email', res.data.user.email);
            localStorage.setItem('name', res.data.user.name);
            const decodedUser = jwtDecode(res.data.token);
            console.log('Decoded user:', decodedUser);
            setUser(decodedUser);
            return true;
        } catch (error) {
            console.error('Login error:', error);
            return false;
        }
    };

    const register = async (name, email, password) => {
        try {
            const res = await axios.post('https://fitsaveai.uk.r.appspot.com/api/auth/register', { name, email, password });
            localStorage.setItem('name', res.data.user.name);
            localStorage.setItem('email', res.data.user.email);
            localStorage.setItem('token', res.data.token);
            const decodedUser = jwtDecode(res.data.token);
            console.log('Registered user:', decodedUser);
            setUser(decodedUser);
            return true;
        } catch (error) {
            console.error('Registration error:', error);
            return false;
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('name');
        setUser(null);
    };

    const verifyToken = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const res = await axios.get('https://fitsaveai.uk.r.appspot.com/api/auth/verify', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setUser(res.data.user);
            } catch (error) {
                console.error('Token verification error:', error);
                localStorage.removeItem('token');
                setUser(null);
            }
        }
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, register, logout, loading, verifyToken }}>
            {children}
        </AuthContext.Provider>
    );
};